import { t } from '../i18n/I18n.js';
import { isInCheck } from '../game/attacks.js';
import type { Color } from '../game/types.js';
import type { TurnBannerView } from '../render/overlay/TurnBanner.js';
import { resultTitle, sideLabel } from './GameOverHost.js';
import type { Match } from './Match.js';

/** Banner text: the result once over, the bot thinking, or whose move it is. */
export function bannerFor(match: Match, perspective: Color | null): TurnBannerView {
  const state = match.state;
  if (state.outcome !== null) {
    const { winner } = state.outcome;
    return { text: resultTitle({ outcome: state.outcome, perspective }), tone: winner === null ? 'draw' : 'win', dot: winner };
  }
  if (match.botThinking) return { text: t('game.banner.botThinking'), tone: 'turn', dot: state.turn };
  const check = isInCheck(state.position.board, state.turn);
  if (perspective !== null && state.turn === perspective) {
    return { text: t(check ? 'game.banner.yourMoveCheck' : 'game.banner.yourMove'), tone: 'turn', dot: state.turn };
  }
  const side = sideLabel(state.turn);
  return { text: t(check ? 'game.banner.toMoveCheck' : 'game.banner.toMove', { side }), tone: 'turn', dot: state.turn };
}
